namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request_changes extends $.$shm_hitalama_map_widget_float_ai_request_changes {

		prompt(): string {
			const text = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_prompt_changes_short.md' ) )
			return text.replace( '{{Описание изменений}}', this.text() )
		}

		paste() {
			const text = $mol_wire_sync(navigator.clipboard).readText()
			const obj = JSON.parse( text ) as AI_answer

			this.create_md( obj.md_description )
			this.parse_css_selectors( obj )
			this.create_classes( obj.ts_classes )
		}
		
	}
	
	type AI_answer = $shm_hitalama_map_widget_float_ai_request_component_answer

}
